import { render, staticRenderFns } from "./ProductSelectionProductRouterView.vue?vue&type=template&id=400fdbb8&"
import script from "./ProductSelectionProductRouterView.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionProductRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports